export const ProductOverviewRequest = {
  params: '',
  orgYN: '',
  token: '',
  graphToken:'',
  parametersToken: '',
  productCluster: ''
};
